import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  makeStyles,
} from "@fluentui/react-components";
import { FluentIcon } from "@fluentui/react-icons";
import { StyledTooltip } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import useNotificationHandler from "hooks/useNotificationHandler";
import { INotification } from "library/types";
import { useTranslation } from "react-i18next";

type Props = {
  icon: FluentIcon;
  label: string;
  links?: string[];
  isLoading?: boolean;
};

const useStyles = makeStyles({
  popover: {
    maxWidth: "none",
  },
  item: {
    // Fluent caps MenuItem at 290px, which clips the non-wrapping file name
    maxWidth: "none",
    whiteSpace: "nowrap",
  },
});

export const DocumentLinkButton = ({
  icon: Icon,
  label,
  links,
  isLoading,
}: Props) => {
  const { t } = useTranslation();
  const theme = useAppTheme();
  const styles = useStyles();
  const { handleAddNotification } = useNotificationHandler();

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <StyledTooltip content={label} relationship="label">
          <MenuButton
            size="large"
            appearance="transparent"
            icon={<Icon fontSize={24} />}
            disabled={isLoading}
            style={{
              color: theme.palette.purpleDark,
              minWidth: "fit-content",
            }}
          ></MenuButton>
        </StyledTooltip>
      </MenuTrigger>

      <MenuPopover className={styles.popover}>
        <MenuList>
          {links?.map((link) => (
            <MenuItem
              key={link}
              className={styles.item}
              onClick={() => {
                if (!link) {
                  handleAddNotification({
                    id: Date.now().toString(),
                    text: t("hbh.documentNotAvailable.label", {
                      document: label,
                    }),
                    type: "error",
                  } as INotification);
                  return;
                }
                window.open(link, "_blank", "noopener,noreferrer");
              }}
            >
              {decodeURIComponent(
                new URL(link).pathname.split("/").pop() as string,
              )}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
